var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tva-content-switcher"},_vm._l((_vm.content),function(item,index){return _c('div',{key:index,class:[
      'tva-content-switcher-item',
      { active: index === _vm.selectedIndex }
    ],on:{"click":function($event){return _vm.click(index)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }